import React from 'react'
import './button.style.scss'
import PropTypes from 'prop-types'
import { Typography } from '../typography'
import { useTheme } from 'src/components/ThemeContext'

const RadioButton = React.memo(
  (props) => {
    const {
      id,
      label = 'Enter a label for radio',
      name,
      onChange = () => {},
      disabled = false,
      checked = false,
      variant = 'p1',
      labelType = 'regular',
      color,
      className = '',
      labelColor,
      type = 'radio',
      ...rest
    } = props
    const { mode } = useTheme()

    return (
      <label className={`radio__button ${color ? `radio__${color}` : ''} m-0`}>
        <input
          className={`radio__input ${color ? `radio__color__${mode}--${color}` : ''} ${className}`}
          type={type}
          name={name}
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
        <Typography variant={variant} type={labelType} color={labelColor || color} id={id}>
          {label}
        </Typography>
      </label>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.checked === nextProps.checked && prevProps.disabled === nextProps.disabled && prevProps.label === nextProps.label
  },
)

RadioButton.displayName = 'RadioButton'

export default RadioButton

RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
  labelType: PropTypes.string,
  color: PropTypes.string,
  labelColor: PropTypes.string,
  type: PropTypes.string,
}
